import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Clock, Sun, Moon, AlertCircle, XOctagon, ListChecks } from 'lucide-react';
export function WhatsInside() {
  const features = [{
    icon: Clock,
    title: 'Ventanas de sueño por edad',
    desc: 'Descubre cuánto tiempo exacto debe estar despierto tu bebé.'
  }, {
    icon: Sun,
    title: 'Rutina simple para siestas',
    desc: 'Paso a paso para lograr siestas predecibles y sin llanto.'
  }, {
    icon: Moon,
    title: 'Rutina de noche de 10 a 20 min',
    desc: 'El ritual exacto para que entienda que es hora de dormir.'
  }, {
    icon: AlertCircle,
    title: 'Qué hacer en despertares',
    desc: 'Cómo actuar a las 3 AM sin crear nuevos malos hábitos.'
  }, {
    icon: XOctagon,
    title: 'Errores comunes',
    desc: 'Las 5 cosas que empeoran el sueño y cómo evitarlas.'
  }, {
    icon: ListChecks,
    title: 'Checklist imprimible',
    desc: 'Resumen visual para pegar en el refri o cuarto del bebé.'
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-16 md:py-24 px-5 bg-surface/30" data-id="element-116">
      <div className="max-w-5xl mx-auto" data-id="element-117">
        <motion.div className="text-center mb-12 md:mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-heading mb-4" data-id="element-119">
            Qué incluye la guía
          </h2>
          <p className="text-body text-lg" data-id="element-120">
            Todo lo que necesitas, sin relleno innecesario.
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-121">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <motion.div key={i} variants={item} className="bg-cream rounded-2xl p-6 border border-surface shadow-sm hover:shadow-soft transition-shadow duration-300 group" data-id="element-122">
                <div className="w-12 h-12 bg-surface rounded-xl flex items-center justify-center mb-5 group-hover:bg-rose/30 transition-colors" data-id="element-123">
                  <Icon className="w-6 h-6 text-terracotta" data-id="element-124" />
                </div>
                <h3 className="text-lg font-serif font-semibold text-heading mb-2" data-id="element-125">
                  {feature.title}
                </h3>
                <p className="text-body text-sm leading-relaxed" data-id="element-126">
                  {feature.desc}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}